
.TableGrid {
    position: relative;
    display: grid;
    grid-template-columns: var(--TableGrid-columns);

    :global(.rs__cell) {
        position: relative;
        border-width: 0;

        &:global(.rs__header) > :first-child {
            padding: 2px 5px;
        }

        &:global(.rs__time) {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        & > button {
            width: 100%;
            height: 100%;
            padding: 0;
            margin: 0;
            display: flex;
            border-color: var(--soniq-t--global--border--color--time--default) var(--soniq-t--global--border--color--grid--default);
            border-width: 1px 0 0 1px;
            border-style: solid;
            border-radius: 0;
            cursor: pointer;
            transition-duration: 30ms;

            &:hover {
                background: var(--soniq-t--global--background--color--accent--nav--default);
            }
        }

        :global(.rs__event__item) {
            position: absolute;
            z-index: 2;
            left: 3%;
            padding: 1px 0 0 1px;

            &:global(.rs__isBackgroundEvent) {
                z-index: 1;
                left: -1px;

                :global(.MuiPaper-root) {
                    border-radius: 5px 0 0 5px;
                }
            }
        }

        :global(.rs__multi_day) {
            position: absolute;
            z-index: 1;
            text-overflow: ellipsis;
        }

        :global(.rs__block_col) {
            display: block;
            position: relative;
        }

        :global(.rs__hover__op) {
            cursor: pointer;

            &:hover {
                opacity: 0.7;
                text-decoration: underline;
            }
        }
    }
}

@media (max-width: 599.95px) {
    .TableGrid {
        grid-template-columns: var(--TableGrid-columns-sm);
    }

    .TableGrid :global(.rs__cell.rs__time) {
        writing-mode: vertical-rl;
    }
}
